module.exports = __webpack_public_path__ + "assets/img/logAudit-module5-2.a0aa27cd.jpg";